// --------------------------------------------------------------------------
// #90 – Homes activity map
//     - handles the tabs which show and hide the list/map view
// --------------------------------------------------------------------------
// Author:      Alex Baulch & Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var debounce = require('../../utilities/debounce');
var postal = require('postal');
var channel = postal.channel();

/**
 * @module activity-tabs - tabs module for displaying activities in a list or map, just handles the tabs
 * @param  { Object } options - initialisation options
 * @return { Object } object containing all the functions / variables that need to be returned
 */
module.exports = function () {

  /**
   * Init the module
   */
  function init() {
    var allTabLinks = $('[data-binding="tab-link"]');
    var allTabPanels = $('[data-binding="tab-panel"]');
    var loadMoreButton = $('[data-binding="activities-map-listing-load-more"]');

    /**
     * Set a tab link to be active
     * @param { Array } tabLinks - array of elements to set to active
     */
    function setTabLinkActive(tabLinks) {
      for (var i = 0; i < tabLinks.length; i++) {
        $(tabLinks[i]).addClass('active');
      }
    }

    /**
     * Set a tab link to inactive
     * @param { Array } tabLinks - array of tab elements to set to inactive
     */
    function setTabLinkInactive(tabLinks) {
      for (var i = 0; i < tabLinks.length; i++) {
        $(tabLinks[i]).removeClass('active');
      }
    }

    /**
     * Set a tab panel or array of tab panels to be active
     * @param  { Array } tabPanels - array of tab panels ot be made active
     */
    function showTab(tabPanels) {
      for (var i = 0; i < tabPanels.length; i++) {
        $(tabPanels[i]).removeClass('inactive').addClass('active');
      }
    }

    /**
     * Set a tab panel or array of tab panels to be inactive
     * @param  { Array } tabPanels - array of tab panels ot be made inactive
     */
    function hideTab(tabPanels) {
      for (var i = 0; i < tabPanels.length; i++) {
        $(tabPanels[i]).removeClass('active').addClass('inactive');
      }
    }

    /**
     * Get a number representing the active tab
     * @param { Array } tabLinks - array of tab elements to check
     */
    function getActiveLinkIndex(tabLinks) {
      for (var i = 0; i < tabLinks.length; i++) {
        if ($(tabLinks[i]).hasClass('active')) {
          return i;
        }
      }
    }

    var resizeHandler = debounce(function () {
      //Find active link index
      var activeLinkIndex = getActiveLinkIndex(allTabLinks);

      if ($(window).outerWidth() > 768) {
        hideTab(allTabPanels);
        showTab($(allTabPanels.get(activeLinkIndex)));
      } else {
        hideTab(allTabPanels);
        showTab(allTabPanels.last());
      }
    }, 250);

    loadMoreButton.hide();

    $(window).on('resize', resizeHandler).resize();

    setTabLinkActive(allTabLinks.first());

    allTabLinks.on('click', function (e) {
      e.preventDefault();

      var buttonClicked = this;
      var href = $(this).attr('href');
      var currentTab = allTabPanels.filter('.active');
      var correspondingTab = allTabPanels.filter(href);

      var isAlreadyActive = correspondingTab.hasClass('active');

      channel.publish('tabChange', {
        update: 'tabchange',
        thisTabHref: href
      });

      if (!isAlreadyActive) {
        if (href.indexOf('list-view') === -1) {
          $('[data-binding="activities-map-listing-load-more"]').hide();
        } else {
          $('[data-binding="activities-map-listing-load-more"]').show();
        }

        setTabLinkInactive(allTabLinks);
        setTabLinkActive([buttonClicked]);

        showTab(correspondingTab);
        hideTab(currentTab);
      }
    });
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/activities/activity-tabs.js
// module id = 201
// module chunks = 0